import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle, Calendar, DollarSign, User, FileText } from 'lucide-react';
import { apiService as api } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { companyInfo } from '../data/mock';

// 30 Frases motivacionais e de conquista
const MENSAGENS_MOTIVACIONAIS = [
  "🚀 Sua jornada rumo ao sucesso começa agora! Você tomou a decisão certa!",
  "💪 Liberdade conquistada! Cada quilômetro será uma vitória sua!",
  "⭐ Você está construindo o seu futuro, uma pedalada de cada vez!",
  "🎯 Parabéns! Você acabou de dar o primeiro passo para a independência!",
  "🔥 Determinação é o seu combustível. Sucesso é o seu destino!",
  "🌟 Sonhos não têm limite quando você está no comando!",
  "💎 Você escolheu investir em você. Essa é a melhor decisão!",
  "🏆 Sua conquista começa aqui! Aproveite cada momento dessa jornada!",
  "✨ Liberdade não tem preço. Você acabou de conquistar a sua!",
  "🎊 Novo capítulo, novas oportunidades! Você está pronto para brilhar!",
  "🚦 Sinal verde para o seu sucesso! Acelere rumo aos seus objetivos!",
  "💫 Cada km rodado é um passo mais perto da sua realização!",
  "🌈 O futuro pertence àqueles que acreditam. Você acreditou e conquistou!",
  "⚡ Energia positiva, atitude vencedora! Você está imparável!",
  "🎪 A vida é uma aventura. Você acabou de ganhar o seu passaporte!",
  "🌠 Estrelas brilham para quem tem coragem. Você tem!",
  "🎁 Você se presenteou com liberdade. Aproveite cada segundo!",
  "🔑 Você acabou de abrir a porta para infinitas possibilidades!",
  "🎨 Pinte o seu futuro com as cores do sucesso!",
  "🏅 Campeão é quem não desiste. Você está no caminho certo!",
  "🌺 Floresça onde você estiver plantado. Sua hora chegou!",
  "🎵 Sua história está sendo escrita. Faça valer cada página!",
  "🦅 Voe alto! O céu não é o limite quando você tem determinação!",
  "💝 Você investiu em si mesmo. Esse é o melhor investimento!",
  "🌻 Crescimento é constante quando você tem foco. Continue assim!",
  "🎭 Você é o protagonista da sua história. Aproveite o palco!",
  "🏖️ Liberdade é a praia. Você acabou de chegar nela!",
  "🎯 Foco, força e fé! Você tem tudo para conquistar!",
  "🌍 O mundo é seu quando você tem coragem de ir atrás!",
  "🎆 Brilhe! Você merece todo o sucesso que está por vir!"
];

// Função para selecionar mensagem aleatória
const getMensagemAleatoria = () => {
  const indiceAleatorio = Math.floor(Math.random() * MENSAGENS_MOTIVACIONAIS.length);
  return MENSAGENS_MOTIVACIONAIS[indiceAleatorio];
};

export const ReservaPage = () => {
  console.log('🔄 ReservaPage renderizou');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [mensagemMotivacional, setMensagemMotivacional] = useState('');
  const [formData, setFormData] = useState({
    nome_completo: '',
    cpf: '',
    data_nascimento: '',
    numero_cnh: '',
    validade_cnh: '',
    telefone: '',
    email: '',
    endereco: '',
    profissao: '',
    estado_civil: '',
    valor_caucao: 700,
    valor_primeira_semana: 349.99,
    confirmou_pagamento: false,
    tipo_retirada: 'agendado',
    data_retirada: '',
    cor_moto_desejada: 'preta',
    plano_escolhido: 'anual',
    observacoes: '',
    // Documentos
    arquivo_cnh: null,
    arquivo_comprovante: null,
    // Questionário
    uso_principal: '',
    uso_principal_outro: '',
    horas_uso_dia: '',
    tempo_permanencia: '',
    outras_pessoas_conduzem: '',
    possui_cnh_a: 'sim',
    cuidado_veiculo: '',
    objetivo_locacao: '',
    objetivo_locacao_outro: '',
    interesse_fidelidade: '',
    como_conheceu: '',
    como_conheceu_outro: '',
    compromisso_pagamento: ''
  });

  const cores = ['Preta', 'Branca', 'Vermelha', 'Azul', 'Verde'];
  const planos = [
    { value: 'mensal', label: 'Plano Mensal (Carência 3 meses)', valor: 400.00 },
    { value: 'anual', label: 'Plano Anual (Carência 1 ano)', valor: 349.99 },
    { value: 'fidelidade', label: 'Plano Fidelidade', valor: 425.00 }
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === 'plano_escolhido') {
      const planoSelecionado = planos.find(p => p.value === value);
      console.log('📋 Plano selecionado:', value, planoSelecionado);
      setFormData(prev => ({
        ...prev,
        plano_escolhido: value,
        valor_primeira_semana: planoSelecionado ? planoSelecionado.valor : 349.99
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const valorTotal = formData.valor_caucao + formData.valor_primeira_semana;

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('🎯 handleSubmit chamado');
    console.log('📋 formData:', formData);
    
    // Validação dos campos obrigatórios
    if (!formData.nome_completo?.trim()) {
      alert('Por favor, preencha o nome completo.');
      return;
    }
    if (!formData.cpf?.trim()) {
      alert('Por favor, preencha o CPF.');
      return;
    }
    if (!formData.telefone?.trim()) {
      alert('Por favor, preencha o telefone.');
      return;
    }
    if (!formData.email?.trim()) {
      alert('Por favor, preencha o email.');
      return;
    }
    
    // Validação manual do checkbox
    if (!formData.confirmou_pagamento) {
      alert('Por favor, confirme que tem o valor disponível para pagamento.');
      return;
    }
    
    setLoading(true);

    try {
      console.log('📤 Enviando reserva para API...');
      
      // Primeiro cria a reserva
      const resultado = await api.cadastrarReserva(formData);
      console.log('✅ Reserva criada com sucesso:', resultado);
      
      // Depois faz upload dos documentos se tiver cliente_id
      if (resultado.cliente_id) {
        console.log('📤 Fazendo upload dos documentos...');
        
        // Upload CNH
        if (formData.arquivo_cnh) {
          const formDataCNH = new FormData();
          formDataCNH.append('arquivo', formData.arquivo_cnh);
          formDataCNH.append('tipo', 'CNH');
          formDataCNH.append('descricao', 'CNH enviada na reserva online');
          
          try {
            await api.uploadArquivoCliente(resultado.cliente_id, formDataCNH);
            console.log('✅ CNH enviada com sucesso');
          } catch (error) {
            console.error('⚠️ Erro ao enviar CNH:', error);
          }
        }
        
        // Upload Comprovante
        if (formData.arquivo_comprovante) {
          const formDataComprovante = new FormData();
          formDataComprovante.append('arquivo', formData.arquivo_comprovante);
          formDataComprovante.append('tipo', 'COMPROVANTE_RESIDENCIA');
          formDataComprovante.append('descricao', 'Comprovante de residência enviado na reserva online');
          
          try {
            await api.uploadArquivoCliente(resultado.cliente_id, formDataComprovante);
            console.log('✅ Comprovante enviado com sucesso');
          } catch (error) {
            console.error('⚠️ Erro ao enviar comprovante:', error);
          }
        }
      }
      
      // Seleciona mensagem motivacional aleatória
      const mensagem = getMensagemAleatoria();
      console.log('💬 Mensagem motivacional selecionada:', mensagem);
      setMensagemMotivacional(mensagem);
      setSucesso(true);
      console.log('🎉 Estado sucesso setado para true');
      // Não redireciona mais automaticamente
    } catch (error) {
      console.error('❌ Erro ao enviar reserva:', error);
      console.error('❌ Detalhes do erro:', error.response?.data || error.message);
      alert(`Erro ao enviar reserva: ${error.response?.data?.detail || error.message || 'Erro desconhecido'}. Por favor, tente novamente.`);
    } finally {
      setLoading(false);
      console.log('🔄 Loading finalizado');
    }
  };

  if (sucesso) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center p-4">
        <Card className="max-w-md w-full">
          <CardContent className="pt-6 text-center">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
              <CheckCircle className="w-12 h-12 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">🎉 Parabéns!</h2>
            
            {/* Mensagem Motivacional Aleatória */}
            <div className="bg-gradient-to-r from-green-100 to-emerald-100 border-2 border-green-300 rounded-lg p-4 mb-4">
              <p className="text-lg font-semibold text-gray-800 leading-relaxed">
                {mensagemMotivacional}
              </p>
            </div>
            
            {formData.tipo_retirada === 'imediato' ? (
              <>
                <div className="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-4 mb-4">
                  <p className="text-gray-900 font-semibold mb-2">⚡ Retirada Imediata Solicitada!</p>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Em até <strong className="text-green-600">5 minutos</strong> vamos enviar o contrato 
                    para assinatura pelo <strong>WhatsApp</strong> e direcionaremos você para realizar 
                    a retirada da sua moto!
                  </p>
                </div>
                <p className="text-gray-600 text-sm mb-4">
                  Nossa equipe já foi notificada e entrará em contato imediatamente!
                </p>
              </>
            ) : (
              <>
                <p className="text-gray-600 mb-4">
                  Recebemos sua reserva! Nossa equipe entrará em contato via WhatsApp em breve 
                  para finalizar os detalhes.
                </p>
              </>
            )}
            
            <div className="flex gap-2 mt-6">
              <Button
                onClick={() => window.location.href = '/'}
                variant="outline"
                className="flex-1"
              >
                Voltar ao Início
              </Button>
              <Button
                onClick={() => window.open(`https://wa.me/${companyInfo.whatsapp.replace(/\D/g, '')}`, '_blank')}
                className="flex-1 bg-green-600 hover:bg-green-700 text-white"
              >
                Abrir WhatsApp
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-green-50 py-12 px-4 light-theme">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-50 border border-green-100 mb-4">
            <Calendar className="w-4 h-4 text-green-600" />
            <span className="text-sm font-medium text-green-700">Faça sua Reserva Online</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Reserve Sua Moto
          </h1>
          <p className="text-lg text-gray-600">
            Preencha o formulário e entraremos em contato para finalizar
          </p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          {/* Dados Pessoais */}
          <Card className="mb-6">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <User className="w-5 h-5 text-green-600" />
                Dados Pessoais
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nome Completo *</label>
                  <input
                    type="text"
                    name="nome_completo"
                    value={formData.nome_completo}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">CPF *</label>
                  <input
                    type="text"
                    name="cpf"
                    value={formData.cpf}
                    onChange={handleChange}
                    required
                    placeholder="000.000.000-00"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data de Nascimento *</label>
                  <input
                    type="date"
                    name="data_nascimento"
                    value={formData.data_nascimento}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Número da CNH *</label>
                  <input
                    type="text"
                    name="numero_cnh"
                    value={formData.numero_cnh}
                    onChange={handleChange}
                    required
                    placeholder="00000000000"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Validade da CNH *</label>
                  <input
                    type="date"
                    name="validade_cnh"
                    value={formData.validade_cnh}
                    onChange={handleChange}
                    required
                    min={new Date().toISOString().split('T')[0]}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Telefone/WhatsApp *</label>
                  <input
                    type="tel"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleChange}
                    required
                    placeholder="(13) 99999-9999"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">E-mail *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Endereço Completo *</label>
                  <input
                    type="text"
                    name="endereco"
                    value={formData.endereco}
                    onChange={handleChange}
                    required
                    placeholder="Rua, número, bairro, cidade, estado"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Profissão *</label>
                  <input
                    type="text"
                    name="profissao"
                    value={formData.profissao}
                    onChange={handleChange}
                    required
                    placeholder="Ex: Motoboy, Vendedor, Autônomo"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Estado Civil *</label>
                  <select
                    name="estado_civil"
                    value={formData.estado_civil}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  >
                    <option value="">Selecione</option>
                    <option value="solteiro">Solteiro(a)</option>
                    <option value="casado">Casado(a)</option>
                    <option value="divorciado">Divorciado(a)</option>
                    <option value="viuvo">Viúvo(a)</option>
                    <option value="uniao_estavel">União Estável</option>
                  </select>
                </div>
              </div>
            </CardContent>
          </Card>


          {/* Questionário de Perfil */}
          <Card className="mb-6 bg-gradient-to-br from-green-50 to-white border-green-200">
            <CardHeader>
              <h2 className="text-2xl font-bold text-green-800 flex items-center gap-2">
                <span className="text-2xl">📋</span>
                Conte-nos um pouco sobre você
              </h2>
              <p className="text-sm text-gray-600 mt-1">Isso nos ajuda a oferecer o melhor serviço para seu perfil</p>
            </CardHeader>
            <CardContent>
              
              {/* Seção 1: Uso e Rotina */}
              <div className="mb-6 p-4 bg-white rounded-lg border border-green-100">
                <h3 className="font-semibold text-green-700 mb-3 flex items-center gap-2">
                  <span>🏍️</span> Uso e Rotina
                </h3>
                
                <div className="space-y-4">
                  {/* Uso principal */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Qual será o principal uso da moto?
                    </label>
                    <div className="space-y-2">
                      {[
                        { value: 'trabalho_fixo', label: 'Trabalho fixo (ex: entregas, deslocamento diário)' },
                        { value: 'aplicativos', label: 'Aplicativos (ex: iFood, Rappi, 99 etc.)' },
                        { value: 'uso_pessoal', label: 'Uso pessoal / locomoção' },
                        { value: 'outro', label: 'Outro' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 p-2 rounded">
                          <input
                            type="radio"
                            name="uso_principal"
                            value={option.value}
                            checked={formData.uso_principal === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm text-gray-700">{option.label}</span>
                        </label>
                      ))}
                      {formData.uso_principal === 'outro' && (
                        <input
                          type="text"
                          name="uso_principal_outro"
                          placeholder="Especifique..."
                          value={formData.uso_principal_outro}
                          onChange={handleChange}
                          className="ml-6 px-3 py-2 border border-gray-300 rounded-lg text-sm w-full max-w-md bg-white text-gray-900"
                        />
                      )}
                    </div>
                  </div>

                  {/* Horas de uso */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Quantas horas por dia, em média, você pretende utilizá-la?
                    </label>
                    <div className="flex flex-wrap gap-3">
                      {[
                        { value: 'ate_4h', label: 'Até 4h' },
                        { value: '4h_8h', label: 'De 4h a 8h' },
                        { value: 'mais_8h', label: 'Mais de 8h' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 px-4 py-2 rounded-lg border border-gray-200">
                          <input
                            type="radio"
                            name="horas_uso_dia"
                            value={option.value}
                            checked={formData.horas_uso_dia === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm font-medium text-gray-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Tempo permanência */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Por quanto tempo pretende permanecer com a moto?
                    </label>
                    <div className="flex flex-wrap gap-3">
                      {[
                        { value: 'ate_1mes', label: 'Até 1 mês' },
                        { value: '1_3meses', label: 'De 1 a 3 meses' },
                        { value: 'longo_prazo', label: 'Longo prazo' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 px-4 py-2 rounded-lg border border-gray-200">
                          <input
                            type="radio"
                            name="tempo_permanencia"
                            value={option.value}
                            checked={formData.tempo_permanencia === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm font-medium text-gray-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Seção 2: Perfil e Responsabilidade */}
              <div className="mb-6 p-4 bg-white rounded-lg border border-green-100">
                <h3 className="font-semibold text-green-700 mb-3 flex items-center gap-2">
                  <span>👤</span> Perfil e Responsabilidade
                </h3>
                
                <div className="space-y-4">
                  {/* Outras pessoas */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Outras pessoas também irão conduzir a moto?
                    </label>
                    <div className="flex gap-4">
                      {['sim', 'nao'].map(option => (
                        <label key={option} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 px-4 py-2 rounded-lg border border-gray-200">
                          <input
                            type="radio"
                            name="outras_pessoas_conduzem"
                            value={option}
                            checked={formData.outras_pessoas_conduzem === option}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm font-medium text-gray-700 capitalize">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Cuidado veículo */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Como você costuma cuidar dos seus veículos?
                    </label>
                    <div className="space-y-2">
                      {[
                        { value: 'zelo_manutencao', label: 'Tenho zelo e atenção com manutenção e limpeza' },
                        { value: 'uso_necessario', label: 'Uso apenas para o necessário' },
                        { value: 'terceirizo', label: 'Costumo terceirizar cuidados' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 p-2 rounded">
                          <input
                            type="radio"
                            name="cuidado_veiculo"
                            value={option.value}
                            checked={formData.cuidado_veiculo === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm text-gray-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Seção 3: Objetivo */}
              <div className="mb-6 p-4 bg-white rounded-lg border border-green-100">
                <h3 className="font-semibold text-green-700 mb-3 flex items-center gap-2">
                  <span>🎯</span> Seu Objetivo
                </h3>
                
                <div className="space-y-4">
                  {/* Objetivo locação */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Qual é o seu principal objetivo com a locação?
                    </label>
                    <div className="space-y-2">
                      {[
                        { value: 'trabalhar_gerar_renda', label: 'Trabalhar e gerar renda' },
                        { value: 'temporario_ate_comprar', label: 'Ter uma moto temporária até comprar a minha' },
                        { value: 'fidelidade_conquistar', label: 'Fazer parte do Plano Fidelidade para conquistar a moto' },
                        { value: 'outro', label: 'Outro' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 p-2 rounded">
                          <input
                            type="radio"
                            name="objetivo_locacao"
                            value={option.value}
                            checked={formData.objetivo_locacao === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm text-gray-700">{option.label}</span>
                        </label>
                      ))}
                      {formData.objetivo_locacao === 'outro' && (
                        <input
                          type="text"
                          name="objetivo_locacao_outro"
                          placeholder="Especifique..."
                          value={formData.objetivo_locacao_outro}
                          onChange={handleChange}
                          className="ml-6 px-3 py-2 border border-gray-300 rounded-lg text-sm w-full max-w-md bg-white text-gray-900"
                        />
                      )}
                    </div>
                  </div>

                  {/* Interesse fidelidade */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Gostaria de fidelizar e conquistar sua própria moto com o tempo?
                    </label>
                    <div className="space-y-2">
                      {[
                        { value: 'sim_quero', label: '✅ Sim, quero participar!' },
                        { value: 'talvez', label: '🤔 Talvez, quero entender melhor' },
                        { value: 'nao_curto_prazo', label: '⏱️ Não, quero apenas alugar por período curto' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 p-3 rounded-lg border border-gray-200">
                          <input
                            type="radio"
                            name="interesse_fidelidade"
                            value={option.value}
                            checked={formData.interesse_fidelidade === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm font-medium text-gray-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Seção 4: Finalizando */}
              <div className="p-4 bg-white rounded-lg border border-green-100">
                <h3 className="font-semibold text-green-700 mb-3 flex items-center gap-2">
                  <span>💬</span> Para Finalizarmos
                </h3>
                
                <div className="space-y-4">
                  {/* Como conheceu */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Como você nos conheceu?
                    </label>
                    <div className="flex flex-wrap gap-3">
                      {[
                        { value: 'indicacao', label: '👥 Indicação' },
                        { value: 'instagram', label: '📸 Instagram' },
                        { value: 'google', label: '🔍 Google' },
                        { value: 'outro', label: '📝 Outro' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 px-4 py-2 rounded-lg border border-gray-200">
                          <input
                            type="radio"
                            name="como_conheceu"
                            value={option.value}
                            checked={formData.como_conheceu === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm font-medium text-gray-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                    {formData.como_conheceu === 'outro' && (
                      <input
                        type="text"
                        name="como_conheceu_outro"
                        placeholder="Conte-nos..."
                        value={formData.como_conheceu_outro}
                        onChange={handleChange}
                        className="mt-2 px-3 py-2 border border-gray-300 rounded-lg text-sm w-full"
                      />
                    )}
                  </div>

                  {/* Compromisso pagamento */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Como você definiria seu compromisso com prazos de pagamento?
                    </label>
                    <div className="space-y-2">
                      {[
                        { value: 'sempre_cumpro', label: '⭐ Sempre cumpro com o combinado' },
                        { value: 'as_vezes_atraso', label: '⚠️ Às vezes atraso, mas regularizo rápido' },
                        { value: 'prefiro_combinar', label: '🤝 Prefiro combinar conforme minha rotina' }
                      ].map(option => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer hover:bg-green-50 p-3 rounded-lg border border-gray-200">
                          <input
                            type="radio"
                            name="compromisso_pagamento"
                            value={option.value}
                            checked={formData.compromisso_pagamento === option.value}
                            onChange={handleChange}
                            className="text-green-600 focus:ring-green-500"
                          />
                          <span className="text-sm text-gray-700">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
                <p className="text-sm text-green-800">
                  <span className="font-semibold">✨ Obrigado!</span> Suas respostas nos ajudam a personalizar seu atendimento e garantir a melhor experiência.
                </p>
              </div>

            </CardContent>
          </Card>

          {/* Upload de Documentos */}
          <Card className="mb-6 border-2 border-green-200 bg-gradient-to-br from-white to-green-50">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="w-5 h-5 text-green-600" />
                Upload de Documentos *
              </CardTitle>
              <p className="text-sm text-gray-600 mt-2">
                Para agilizar seu atendimento, envie seus documentos agora
              </p>
            </CardHeader>
            <CardContent className="space-y-6">
              {/* CNH Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  📄 CNH (Frente e Verso) <span className="text-gray-400 font-normal">(opcional)</span>
                </label>
                <input
                  type="file"
                  name="cnh"
                  accept="image/*,.pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setFormData(prev => ({
                      ...prev,
                      arquivo_cnh: file
                    }));
                  }}
                  className="w-full px-4 py-3 border-2 border-dashed border-green-300 rounded-lg hover:border-green-500 transition-colors cursor-pointer focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white"
                />
                {formData.arquivo_cnh && (
                  <div className="mt-2 flex items-center gap-2 text-sm text-green-600">
                    <CheckCircle className="w-4 h-4" />
                    <span>Arquivo selecionado: {formData.arquivo_cnh.name}</span>
                  </div>
                )}
                <p className="mt-1 text-xs text-gray-500">
                  Formatos aceitos: JPG, PNG, PDF | Tamanho máximo: 10MB
                </p>
              </div>

              {/* Comprovante de Residência Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  🏠 Comprovante de Residência <span className="text-gray-400 font-normal">(opcional)</span>
                </label>
                <input
                  type="file"
                  name="comprovante"
                  accept="image/*,.pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setFormData(prev => ({
                      ...prev,
                      arquivo_comprovante: file
                    }));
                  }}
                  className="w-full px-4 py-3 border-2 border-dashed border-green-300 rounded-lg hover:border-green-500 transition-colors cursor-pointer focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white"
                />
                {formData.arquivo_comprovante && (
                  <div className="mt-2 flex items-center gap-2 text-sm text-green-600">
                    <CheckCircle className="w-4 h-4" />
                    <span>Arquivo selecionado: {formData.arquivo_comprovante.name}</span>
                  </div>
                )}
                <p className="mt-1 text-xs text-gray-500">
                  Conta de luz, água, telefone ou extrato bancário | Máximo: 10MB
                </p>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-800">
                  <strong>ℹ️ Documentos opcionais</strong>
                  <br />
                  Você pode enviar os documentos agora ou depois. Nossa equipe entrará em contato via WhatsApp para finalizar a reserva.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Detalhes da Reserva */}
          <Card className="mb-6">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Calendar className="w-5 h-5 text-green-600" />
                Detalhes da Reserva
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Plano Escolhido *</label>
                  <select
                    name="plano_escolhido"
                    value={formData.plano_escolhido}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  >
                    {planos.map(p => (
                      <option key={p.value} value={p.value}>
                        {p.label} - R$ {p.valor.toFixed(2)}/semana
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Cor da Moto *</label>
                  <select
                    name="cor_moto_desejada"
                    value={formData.cor_moto_desejada}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  >
                    {cores.map(cor => (
                      <option key={cor.toLowerCase()} value={cor.toLowerCase()}>{cor}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Retirada *</label>
                  <select
                    name="tipo_retirada"
                    value={formData.tipo_retirada}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  >
                    <option value="imediato">Imediato</option>
                    <option value="agendado">Agendar Data</option>
                  </select>
                </div>
                {formData.tipo_retirada === 'agendado' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data de Retirada *</label>
                    <input
                      type="date"
                      name="data_retirada"
                      value={formData.data_retirada}
                      onChange={handleChange}
                      required={formData.tipo_retirada === 'agendado'}
                      min={new Date().toISOString().split('T')[0]}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                    />
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Observações</label>
                <textarea
                  name="observacoes"
                  value={formData.observacoes}
                  onChange={handleChange}
                  rows={3}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-900"
                  placeholder="Alguma informação adicional?"
                />
              </div>
            </CardContent>
          </Card>

          {/* Confirmação Financeira */}
          <Card className="mb-6">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <DollarSign className="w-5 h-5 text-green-600" />
                Confirmação Financeira
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <h4 className="font-semibold text-gray-900 mb-2">Valores a Pagar na Retirada:</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Caução (devolvível):</span>
                    <span className="font-semibold">R$ {formData.valor_caucao.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Primeira Semana ({planos.find(p => p.value === formData.plano_escolhido)?.label}):</span>
                    <span className="font-semibold">R$ {formData.valor_primeira_semana.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between pt-2 border-t border-green-200">
                    <span className="font-bold text-gray-900">Total:</span>
                    <span className="font-bold text-green-600">R$ {valorTotal.toFixed(2)}</span>
                  </div>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <input
                  type="checkbox"
                  id="confirmou_pagamento"
                  name="confirmou_pagamento"
                  checked={formData.confirmou_pagamento}
                  onChange={handleChange}
                  className="mt-1 w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                />
                <label htmlFor="confirmou_pagamento" className="text-sm text-gray-700">
                  <strong>Confirmo que tenho o valor total disponível (R$ {valorTotal.toFixed(2)})</strong> para pagamento no momento da retirada da moto.
                </label>
              </div>
            </CardContent>
          </Card>

          {/* Botões */}
          <div className="flex gap-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate('/')}
              className="flex-1"
            >
              Voltar
            </Button>
            <Button
              type="submit"
              disabled={loading || !formData.confirmou_pagamento}
              className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Enviando Reserva...' : 'Confirmar Reserva'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};